import { Badge as MuiBadge, badgeClasses, type BadgeOwnProps, styled } from '@mui/material';
import { type Theme } from '@mui/material/styles';
import { mergeSx } from 'merge-sx';

const Badge = styled(MuiBadge)(({ color, theme: { palette, spacing } }) => ({
  [`& .${badgeClasses.badge}`]: mergeSx(
    {
      width: spacing(0.75),
      minWidth: spacing(0.75),
      height: spacing(0.75),
      transform: 'unset',
      border: `1.25px solid ${palette.background.default}`
    },
    color && {
      backgroundColor: getBadgeColor(color, palette)
    }
  )
}));

const getBadgeColor = (color: BadgeOwnProps['color'], palette: Theme['palette']) => {
  switch (color) {
    case 'success':
      return palette.green.main;
  }
};

export default Badge;
